/* src/app/components/billing/files/view-files/view-files.component.css */
/*# sourceMappingURL=view-files.component-SWA2WJTL.css.map */
